// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Chip$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/chip/Chip.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as MuiTabs$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/tabs/MuiTabs.bs.js";
import * as AllocationCampaignTable from "./AllocationCampaignTable.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as AllocationDashboardDataMachine from "../../../../app/repo/AllocationDashboardDataMachine.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function getCampaignStatusCount(data, tab) {
  return Belt_List.length(List.filter(function (campaign) {
                    return campaign.campaign_status === tab;
                  })(data.campaigns));
}

function getTabsList(data) {
  return {
          hd: {
            tabId: /* Active */0,
            label: {
              TAG: /* Custom */1,
              _0: (function (param) {
                  var activeCampaignCount = getCampaignStatusCount(data, /* Active */0);
                  return React.createElement("div", {
                              className: "campaign-tab"
                            }, React.createElement("p", {
                                  className: "tab-name"
                                }, "Active"), activeCampaignCount === 0 ? null : React.createElement(Chip$Catalyst.make, {
                                    title: {
                                      TAG: /* Text */0,
                                      _0: String(activeCampaignCount)
                                    },
                                    className: "count"
                                  }));
                })
            },
            icon: null,
            disabled: false,
            tooltip: undefined
          },
          tl: {
            hd: {
              tabId: /* Scheduled */1,
              label: {
                TAG: /* Custom */1,
                _0: (function (param) {
                    var scheduledCampaignCount = getCampaignStatusCount(data, /* Scheduled */1);
                    return React.createElement("div", {
                                className: "campaign-tab"
                              }, React.createElement("p", {
                                    className: "tab-name"
                                  }, "Scheduled"), scheduledCampaignCount === 0 ? null : React.createElement(Chip$Catalyst.make, {
                                      title: {
                                        TAG: /* Text */0,
                                        _0: String(scheduledCampaignCount)
                                      },
                                      className: "count"
                                    }));
                  })
              },
              icon: null,
              disabled: false,
              tooltip: undefined
            },
            tl: {
              hd: {
                tabId: /* PendingForReview */2,
                label: {
                  TAG: /* Custom */1,
                  _0: (function (param) {
                      var pendingCampaignCount = getCampaignStatusCount(data, /* PendingForReview */2);
                      return React.createElement("div", {
                                  className: "campaign-tab"
                                }, React.createElement("p", {
                                      className: "tab-name"
                                    }, "Pending for review"), pendingCampaignCount === 0 ? null : React.createElement(Chip$Catalyst.make, {
                                        title: {
                                          TAG: /* Text */0,
                                          _0: String(pendingCampaignCount)
                                        },
                                        className: "count"
                                      }));
                    })
                },
                icon: null,
                disabled: false,
                tooltip: undefined
              },
              tl: /* [] */0
            }
          }
        };
}

var Tabs = {
  getTabsList: getTabsList
};

function getCampaingsbyStatus(data, tab) {
  return List.filter(function (campaign) {
                return campaign.campaign_status === tab;
              })(data.campaigns);
}

function getPayload(region, vehicle) {
  return {
          geo_region_id: region.id,
          vehicle_id: vehicle.vehicle_id,
          campaign_type: undefined,
          start_time: undefined,
          end_time: undefined
        };
}

function AllocationCampaignList(Props) {
  var state = Props.state;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return /* Active */0;
      });
  var currentTab = match$1[0];
  React.useEffect((function () {
          var match = state.selected_geo_region;
          var match$1 = state.selected_vehicle;
          var match$2 = state.refresh_campaign_list;
          if (match !== undefined && match$1 !== undefined && match$2) {
            AllocationDashboardDataMachine.fetchAllocationCampaigns(getPayload(match, match$1), (function (data) {
                    return Curry._1(dispatch, {
                                TAG: /* SetAllocationCamapigns */9,
                                filtered_allocation_campaings: {
                                  TAG: /* Live */1,
                                  _0: data
                                },
                                refresh_campaign_list: false
                              });
                  }), (function (error) {
                    return Curry._1(dispatch, {
                                TAG: /* SetAllocationCamapigns */9,
                                filtered_allocation_campaings: {
                                  TAG: /* Error */2,
                                  _0: error
                                },
                                refresh_campaign_list: false
                              });
                  }), country);
          }
          
        }), [
        state.selected_vehicle,
        state.selected_geo_region,
        state.refresh_campaign_list
      ]);
  var match$2 = state.selected_vehicle;
  var tmp;
  if (match$2 !== undefined) {
    var match$3 = state.user_role;
    var match$4 = state.filtered_allocation_campaings;
    var exit = 0;
    var error;
    var exit$1 = 0;
    var exit$2 = 0;
    if (typeof match$3 === "number" || match$3.TAG !== /* Live */1) {
      exit$2 = 4;
    } else if (typeof match$4 === "number") {
      exit = 1;
    } else {
      switch (match$4.TAG | 0) {
        case /* Loading */0 :
            exit = 1;
            break;
        case /* Live */1 :
            var data = match$4._0;
            tmp = React.createElement(React.Fragment, undefined, React.createElement(MuiTabs$Catalyst.make, {
                      tabs: getTabsList(data),
                      activeTab: currentTab,
                      setActiveTab: match$1[1]
                    }), state.refresh_campaign_list ? React.createElement(CircularLoader$Catalyst.make, {}) : React.createElement(AllocationCampaignTable.make, {
                        active_campaign: Belt_List.getExn(getCampaingsbyStatus(data, /* Active */0), 0),
                        filtered_campaings_view: getCampaingsbyStatus(data, currentTab),
                        state: state,
                        user_type: match$3._0,
                        dispatch: dispatch
                      }));
            break;
        case /* Error */2 :
            exit$2 = 4;
            break;
        
      }
    }
    if (exit$2 === 4) {
      if (typeof match$4 === "number" || match$4.TAG !== /* Error */2) {
        exit$1 = 3;
      } else {
        error = match$4._0;
        exit = 2;
      }
    }
    if (exit$1 === 3) {
      if (typeof match$3 === "number" || match$3.TAG === /* Loading */0) {
        exit = 1;
      } else {
        error = match$3._0;
        exit = 2;
      }
    }
    switch (exit) {
      case 1 :
          tmp = React.createElement(CircularLoader$Catalyst.make, {});
          break;
      case 2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: error
              });
          break;
      
    }
  } else {
    var error$1 = state.vehicles;
    var exit$3 = 0;
    if (typeof error$1 === "number") {
      exit$3 = 1;
    } else {
      switch (error$1.TAG | 0) {
        case /* Loading */0 :
            exit$3 = 1;
            break;
        case /* Live */1 :
            tmp = React.createElement("h2", {
                  className: "ald-user-helper-text"
                }, "Please select vehicle for new geo region");
            break;
        case /* Error */2 :
            tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                  error: error$1._0
                });
            break;
        
      }
    }
    if (exit$3 === 1) {
      tmp = React.createElement(React.Fragment, undefined, React.createElement("h2", {
                className: "ald-user-helper-text"
              }, "Fetching Vehicles for selected geo region"), React.createElement(CircularLoader$Catalyst.make, {}));
    }
    
  }
  return React.createElement("div", {
              className: "campaings-container"
            }, tmp);
}

var make = AllocationCampaignList;

export {
  getCampaignStatusCount ,
  Tabs ,
  getCampaingsbyStatus ,
  getPayload ,
  make ,
  
}
/* react Not a pure module */
